import {
  AgileIcon,
  AiQueryBotIcon,
  ArchiveIcon,
  BoardIcon,
  CalendarIcon,
  ChatIcon,
  DeleteIcon,
  DocumentIcon,
  DuplicateIcon,
  EmbedViewIcon,
  FormIcon,
  GanttIcon,
  HelpIcon,
  ListIcon,
  MoveIcon,
  PieChartIcon,
  RestoreIcon,
  TimeHourglassIcon,
  WhiteBoardIcon,
  WorksheetIcon,
} from '@sketchnote/icons';

import { UseFilesProps } from '../api/getFiles';

export const tabsData: { label: string; value: UseFilesProps['mode'] }[] = [
  { label: 'Shared', value: 'shared' },
  { label: 'Private', value: 'private' },
];

export const sortOptions: { label: string; value: UseFilesProps['sortValue'] }[] = [
  { label: 'Recent', value: 'recent' },
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'dsc' },
  { label: 'Last', value: 'last' },
];

export const menuItemsAll = [
  { label: 'Archive', value: 'archived', icon: <ArchiveIcon /> },
  { label: 'Delete', value: 'deleted', icon: <DeleteIcon /> },
  { label: 'Move', value: 'move', icon: <MoveIcon /> },
  { label: 'Create Copy', value: 'copy', icon: <DuplicateIcon className="mt-5" /> },
];
export const menuItemsArchive = [
  { label: 'Unarchive', value: 'undo', icon: <RestoreIcon /> },
  { label: 'Delete', value: 'deleted', icon: <DeleteIcon /> },
  { label: 'Move', value: 'move', icon: <MoveIcon /> },
  { label: 'Create Copy', value: 'copy', icon: <DuplicateIcon className="mt-5" /> },
];

export const menuItemsDelete = [
  { label: 'Restore', value: 'undo', icon: <RestoreIcon /> },
  { label: 'Delete permanently', value: 'delete-permanently', icon: <DeleteIcon /> },
  { label: 'Move', value: 'move', icon: <MoveIcon /> },
  { label: 'Create Copy', value: 'copy', icon: <DuplicateIcon className="mt-5" /> },
];

export const filterOptions: any = [
  { label: 'All files', value: 'all' },
  { label: 'Pinned', value: 'pinned' },
  { label: 'Primary view : Document', value: 'document' },
  { label: 'Primary view : Whiteboard', value: 'whiteboard' },
  { label: 'Primary view : Kanban', value: 'kanban' },
  { label: 'Primary view : Form', value: 'form' },
  { label: 'Primary view : List', value: 'list' },
  { label: 'Primary view : Gantt', value: 'gantt' },
  { label: 'Primary view : Calendar', value: 'calendar' },
  { label: 'Favorites', value: 'favorite' },
  { label: 'Archived', value: 'archived' },
  { label: 'Deleted', value: 'deleted' },
];

export const viewOptions: any = [
  { label: 'List', value: 'list' },
  { label: 'Grid', value: 'grid' },
];

export const startNewFileData = {
  items: [
    {
      title: 'List',
      icon: <ListIcon fill="#131720" size={16} />,
      type: 'board',
      view: 'list',
      description: 'View your tasks in a horizontal list style',
    },
    {
      title: 'Document',
      icon: <DocumentIcon size={16} stroke="#131720" />,
      type: 'document',
      description: 'Make notes on our markdown editor',
    },
  ],
};
export const advancedStartNewFileData = {
  items: [
    // {
    //   title: 'SCRUM',
    //   icon: <AgileIcon fill="#131720" size={16} />,
    //   type: 'agile',
    //   description: 'Set up and run a SCRUM project',
    // },
    {
      title: 'Form',
      icon: <FormIcon stroke="#131720" size={16} />,
      type: 'form',
      description: 'Create a form with various question types',
    },
    {
      title: 'AI QueryBot',
      icon: <AiQueryBotIcon fill="#131720" size={16} />,
      type: 'pdf_chat',
      description: 'Ask AI bot questions about PDF docs',
    },
  ],
};
export const fileIconList = {
  document: <DocumentIcon className="text-base mt-1" />,
  kanban: <BoardIcon className="mt-2" />,
  whiteboard: <WhiteBoardIcon />,
  gantt: <GanttIcon />,
  list: <ListIcon />,
  calendar: <CalendarIcon />,
  form: <FormIcon />,
  timesheet: <TimeHourglassIcon />,
  analytics: <PieChartIcon />,
  embed: <EmbedViewIcon size="1.2em" className="mt-2" />,
  board: <BoardIcon />,
  sheet: <WorksheetIcon />,
  agile: <AgileIcon />,
  chat: <ChatIcon />,
  pdf_chat: <AiQueryBotIcon />,
};

export const fileViewList = {
  document: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/document.png',
    title: 'Document',
    description:
      'Start a fresh document with our markdown editor. Add tasks and assign them to teammates, internally. Export and share files with ease',
    value: 'document',
  },

  whiteboard: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/Whiteboard.png',
    title: 'Whiteboard',
    description:
      'Draw, doodle, and collaborate easily with your team in one place. Use tools like sticky notes and readymade shapes to brainstorm on ideas and create a digital canvas to bring your ideas to life.',

    value: 'whiteboard',
  },
  kanban: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/v1656942637/file_views/Kanban.png',
    title: 'Kanban',
    description:
      'Add and manage tasks with your team on the Kanban board. Drag and drop tasks between columns as you work on them',

    value: 'kanban',
  },
  list: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/list.png',
    title: 'List',
    description:
      'Add tasks to your boards in a horizontal view. Get access to the most relevant information quickly, and move your tasks faster when the status changes',
    value: 'list',
  },
  gantt: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/gantt.png',
    title: 'Gantt',
    description:
      'View your project in a Gantt chart. Perfect for project management and tracking task duration across dates. Identify important tasks using filters easily',

    value: 'gantt',
  },
  calendar: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/calendar.png',
    title: 'Calendar',
    description:
      'Add tasks and sprints to the calendar view. See what projects are due when. Schedule tasks and sprints with ease ',

    value: 'calendar',
  },
  timesheet: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/Time_sheet.png',
    title: 'Timesheet',
    description:
      'View your logged times for tasks in a horizontal list view. Open tasks for detailed time logs and edit them on the fly. Toggle between billable and non-billable hours while editing, and delete time.',
    value: 'timesheet',
  },
  form: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/v1656939893/file_views/form.png',
    title: 'Form',
    description:
      'Create a custom form and collect data easily with this view. Analyze collected data and download responses as well. Perfect for internal and external use cases.',

    value: 'form',
  },
  analytics: {
    imageURL:
      'https://res.cloudinary.com/samvibes/image/upload/v1656939892/file_views/Analytics.png',
    title: 'Analytics',
    description:
      'Get a bird’s eye view of the tasks in your board and keep track of the progress you’re making. Use custom fields to check on completion statuses, assignee load, tasks per teammate and other activity to stay on top of your project.',
    value: 'analytics',
  },
  embed: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/v1661410139/Embed.png',
    title: 'Embed',
    description: 'Add a custom link to your file as a view.',
    value: 'embed',
  },
  sheet: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/v1661410139/Embed.png',
    title: 'Sheet',
    description:
      'Structure your data in a spreadsheet view. Filter your information or run calculations to find the most relevant information in a familiar, grid-based design',
    value: 'sheet',
  },
  chat: {
    imageURL: 'https://res.cloudinary.com/samvibes/image/upload/file_views/Chat.png',
    title: 'Chat',
    description:
      'Begin a conversation with your team in real time. Mention stakeholders and discuss tasks at hand in one place.',
    value: 'chat',
  },
};

export const fileTagColor = [
  '#18B4E5',
  '#FD9740',
  '#EC7DD5',
  '#7AA00D',
  '#211650',
  '#E8584E',
  '#15B9B0',
  '#065B54',
];

export const viewsWithoutFileHeader = ['whiteboard', 'form', 'embed', 'sheet', 'chat', 'pdf_chat'];
export const boardViews = ['kanban', 'list', 'gantt', 'calendar', 'analytics'];
export const pageViews = [
  'document',
  'whiteboard',
  'form',
  'embed',
  'sheet',
  'agile',
  'chat',
  'pdf_chat',
];

export const isTaskView = (view: string) =>
  ['kanban', 'list', 'gantt', 'calendar', 'analytics', 'timesheet'].includes(view);

export const isPageView = (view: string) => pageViews.includes(view);

export const randomColor = [
  '#fbb6ce',
  '#d6bcfa',
  '#9BADEE',
  '#81e6d9',
  '#86E495',
  '#FFE98F',
  '#fbd38d',
  '#FBB1A7',
];

export const getRandomColor = () => {
  return randomColor[Math.floor(Math.random() * randomColor.length)];
};
